module.exports = __webpack_public_path__ + "media/delete_all.5d3027da.mp3";